import * as FastJsonPatch from 'fast-json-patch';
import { produce } from 'immer';

import { JsonPatch, LayoutModel } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

export type PatchTracker = {
  [guid: string]: { type: 'created'; model: LayoutModel } | { type: 'edited'; patches: JsonPatch[] };
};

export function createPatch(property: string, value: any): JsonPatch {
  return {
    op: 'replace',
    path: `/${property}`,
    value,
  };
}

export function applyPatch(model: LayoutModel, patch: JsonPatch) {
  return produce(model, (draft) => {
    FastJsonPatch.applyOperation(draft, patch);
  });
}

export function applyPatches(model: LayoutModel, patches: JsonPatch[]) {
  return produce(model, (draft) => {
    FastJsonPatch.applyPatch(draft, patches);
  });
}

export function createPatchTracker() {
  return {};
}

export function recordCreatedModel(tracker: PatchTracker, model: LayoutModel) {
  tracker[model.guid] = { type: 'created', model };
}

export function recordChangedModel(tracker: PatchTracker, modelGuid: string, patch: JsonPatch) {
  if (modelGuid in tracker) {
    const entry = tracker[modelGuid];

    switch (entry.type) {
      case 'created':
        entry.model = applyPatch(entry.model, patch);
        break;
      case 'edited':
        entry.patches.push(patch);
        break;
      default:
        assertExhaustiveSwitch(entry);
    }
  } else {
    tracker[modelGuid] = { type: 'edited', patches: [patch] };
  }
}

export function recordModelSaved(tracker: PatchTracker, modelGuid: string) {
  delete tracker[modelGuid];
}

export function getModifiedModels(tracker: PatchTracker) {
  return Object.keys(tracker);
}
